// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__24Zmp","buttons":"Footer_buttons__7IXvd"};